import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.822 3.233a1.75 1.75 0 0 1 2.473.003l1.526 1.526a1.75 1.75 0 0 1 0 2.476l-2.277 2.276-.014.016-.016.013L8.027 20.03a.75.75 0 0 1-.418.212l-3.499.532a.75.75 0 0 1-.853-.855l.53-3.5A.75.75 0 0 1 4 16zM5.232 16.889l-.34 2.248 2.247-.342 9.798-9.797-1.886-1.886zM18.233 4.296a.25.25 0 0 0-.352 0l-1.766 1.758 1.883 1.883 1.762-1.76a.25.25 0 0 0 0-.354z"
  }));
}
var IcEdit = createNolIcon(/*#__PURE__*/forwardRef(SvgIcEdit));

export { IcEdit as I };
